module.exports = __webpack_public_path__ + "img/ic-phone-24px.e6cc85e1.svg";